import React from "react";
import { Box, Typography } from "@mui/material";
import { InfoTooltip } from "components/info-tooltip";
import { SectionCardProps } from "./types";
import { SECTION_CARD_SX } from "./styles";

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  icon,
  headerExtra,
  children,
  tooltip,
}) => (
  <Box sx={SECTION_CARD_SX}>
    <Box
      sx={{
        px: 3,
        py: 2,
        borderBottom: "1px solid #F1F5F9",
        background: "linear-gradient(to right, #f8fafc, #ffffff, #f8fafc)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {icon}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, color: "#1A4252", fontSize: "1.0625rem" }}
        >
          {title}
        </Typography>
        {tooltip && <InfoTooltip tooltip={tooltip} />}
      </Box>
      {headerExtra}
    </Box>
    <Box sx={{ p: 3 }}>{children}</Box>
  </Box>
);
